import { TimelineSettingsControlsDependencies } from './types';

const TIMELINE_SETTINGS_DEPENDENCIES_KEYS: (keyof TimelineSettingsControlsDependencies)[] =
  [
    'phaseFieldOptions',
    'milestoneFieldOptions',
    'gridPrecisionOptionsData',
    'availableGridPrecisions',
    'viewModifiers',
  ];

export const isTimelineSettingsControlsDependencies = (
  settingsControlsDependencies: Record<string, any>
): settingsControlsDependencies is TimelineSettingsControlsDependencies =>
  TIMELINE_SETTINGS_DEPENDENCIES_KEYS.every(
    key => key in settingsControlsDependencies
  );
